import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import EntryData from "./entrydata";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const PresidenDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const [loading, setLoading] = useState(true);
  const [presiden, setPresiden] = useState<any>(null);

  const [nama, setNama] = useState("");
  const [jabatan, setJabatan] = useState("");
  const [bidang, setBidang] = useState("");
  const [foto, setFoto] = useState<File | null>(null);

  // popup state
  const [popupType, setPopupType] = useState<"biografi" | "LHKPN" | "kinerja" | null>(null);
  const [popupValue, setPopupValue] = useState("");

  // fetch detail
  useEffect(() => {
    const fetchPresiden = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/presiden/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = res.data;
        setPresiden(data);
        setNama(data.nama || "");
        setJabatan(data.jabatan || "");
        setBidang(data.bidang || "");
      } catch (err) {
        console.error("Gagal fetch detail:", err);
        alert("Gagal memuat data presiden.");
      } finally {
        setLoading(false);
      }
    };
    fetchPresiden();
  }, [id, token]);

  // handle update form utama
  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("nama", nama);
    formData.append("jabatan", jabatan);
    formData.append("bidang", bidang);
    if (foto) formData.append("foto", foto);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/presiden/${id}?_method=PUT`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Data berhasil diperbarui!");
      navigate("/dashboard/presiden");
    } catch (err) {
      console.error("Gagal update:", err);
      alert("Gagal memperbarui data.");
    }
  };

  const handleSavePopup = () => {
    // TODO: simpan ke API sesuai popupType
    console.log("Simpan", popupType, popupValue);
    alert(`${popupType} berhasil disimpan!`);
    setPopupType(null);
    setPopupValue("");
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );
  if (!presiden) return <p>Data tidak ditemukan.</p>;

  return (
    <div className="mt-6 max-w-2xl mx-auto border rounded-sm shadow-sm p-4">
      <Link to="/dashboard/pejabat">
        <div className="flex items-center gap-3 mb-4">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Edit Data Pejabat</h1>
        </div>
      </Link>

      <form onSubmit={handleUpdate} className="space-y-4">
        <div>
          <label className="block font-semibold">Nama</label>
          <input type="text" value={nama} onChange={(e) => setNama(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">Jabatan</label>
          <input type="text" value={jabatan} onChange={(e) => setJabatan(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">Bidang</label>
          <input type="text" value={bidang} onChange={(e) => setBidang(e.target.value)} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block font-semibold">Foto</label>
          <input type="file" accept="image/*" onChange={(e) => setFoto(e.target.files?.[0] || null)} />
          {presiden.foto_url && <img src={presiden.foto} alt={presiden.nama} className="w-40 h-52 object-cover rounded mt-2" />}
        </div>

        <div className="flex justify-between mt-4">
          <button type="submit" className="bg-primary text-white px-4 py-2 rounded">
            Simpan Perubahan
          </button>
        </div>

        {/* ENTRY DATA */}
        <EntryData id={Number(id) || 0} />
      </form>

      {/* POPUP MODAL */}
      {popupType && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6">
            <h2 className="text-lg font-bold mb-4 capitalize">Input {popupType}</h2>
            <textarea className="w-full border rounded p-2 h-32" placeholder={`Tuliskan ${popupType}...`} value={popupValue} onChange={(e) => setPopupValue(e.target.value)} />
            <div className="flex justify-end gap-3 mt-4">
              <button onClick={() => setPopupType(null)} className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400">
                Batal
              </button>
              <button onClick={handleSavePopup} className="px-4 py-2 rounded bg-primary text-white hover:bg-primary/90">
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PresidenDetail;
